import { useAppStore } from "@/stores/appStore"; 

export default {
  replaceWidgetFieldData(item = {}, type, value = this.data) {
    if (!value || !value.component || typeof value.component[type] !== "string") {
      return ""; 
    }

    let template = value.component[type];
   


    template = template.replace(/\{{(.*?)}}/g, (_, key) => {
      return item[key] ?? "";
    });

    template = template.replace(
      /<span data-type="mention" class="mention" data-id="(\d+)" data-label="(.*?)">(.*?)<\/span>/g,
      (_, id, label, innerText) => {
        return item[label] ?? innerText;
      }
    );


    return template.replace(/^<p>(.*?)<\/p>$/, "$1");
  },


   replaceActionData(template, item) {
    if (typeof template !== 'string') return ''
  
    // 1) {{key}} syntax
    template = template.replace(/\{\{(.*?)\}\}/g, (_, key) => {
      return item[key] ?? ''
    })
  
    // 2) <span data-type="mention" … data-label="KEY" …>…</span>
    template = template.replace(
      /<span[^>]*data-type="mention"[^>]*data-label="([^"]+)"[^>]*>.*?<\/span>/g,
      (_, label) => {
        return item[label] ?? ''
      }
    )
  
    // Verwijder optioneel <p>…</p> wrapper
    return template.replace(/^<p>([\s\S]*?)<\/p>$/, '$1')
  },



  replaceFieldToData(item, type, value) {


    if (
      !value ||
      !value.data ||
      !value.data.component ||
      !value.data.component[type]
    ) {
      return ""; // Voeg een lege string of een alternatieve fallback terug
    }

    let template = value.data.component[type];
    if (!template) return "";

    // Replace {{key}} with the actual value from the item object
    template = template.replace(/\{{(.*?)}}/g, (match, key) => {
      return item[key] || "";
    });

    // Replace the <span> elements with mentions (data-label) by getting the corresponding value from the item
    template = template.replace(
      /<span data-type="mention" class="mention" data-id="(\d+)" data-label="(.*?)">(.*?)<\/span>/g,
      (match, id, label, innerText) => {
        const value = item[label] || innerText;
        return value;
      }
    );

    return template.replace(/^<p>(.*?)<\/p>$/, "$1");
  },




  replaceFieldFromDetailPage(item, template) {
    const store = useAppStore();
    let detail = null;
  
    if (store.active.page.screentype === 'profile') {
      detail = store.active.user;
    } else if (store.active.page.screentype === 'form') {
      detail = store.active.collection;
    } else {
      detail = store.active_detail_page || {};
    }

  
    if (!detail || !item || !template || typeof template !== "string") return "";
  
    // Vul {{ key }} met data uit het item
    template = template.replace(/\{{(.*?)}}/g, (_, key) => {
      return item[key.trim()] ?? "";
    });
  
    // Vervang mentions met data uit detail (bv. gebruiker)
    template = template.replace(
      /<span[^>]*data-type="mention"[^>]*data-id="(\d+)"[^>]*data-label="(.*?)"[^>]*>(.*?)<\/span>/g,
      (_, id, label) => {
        const key = label.trim();
        return detail[key] ?? '';
      }
    );
  
    return template.replace(/^<p>(.*?)<\/p>$/, "$1").trim();
  
  },
  

  

  mentionToText(type, value) {
    // value = this.data
    let template = type;
    if (!type || !template || typeof template !== "string") return "";
    template = template.replace(/\{{(.*?)}}/g, (match, p1) => {
      return value.data[p1] || "";
    });

    template = template.replace(
      /<span data-type="mention" class="mention" data-id="(\d+)" data-label="(.*?)">(.*?)<\/span>/g,
      (match, p1, dataLabel, content) => {
        const newValue = value[dataLabel] || "";
        return newValue;
      }
    );

    return template.replace(/^<p>(.*?)<\/p>$/, "$1");
  }
};
